/* tslint:disable */
/* eslint-disable */
export enum DisputeOrderBy {
  Id = 'Id',
  CaseNumber = 'CaseNumber',
  CaseReason = 'CaseReason',
  RaiseDateUtc = 'RaiseDateUtc',
  CaseStatus = 'CaseStatus'
}
